import { on } from '@ngrx/store';

import {
  ManageSurveyActions,
  ManageSurveyApiActions,
} from './manage-survey.actions';
import { ManageSurveyState } from './manage-survey.model';

export const COMMENTS_HANDLERS = [
  on(
    ManageSurveyActions.loadComments,
    (state): ManageSurveyState => ({
      ...state,
      comments: [],
      commentsLoading: true,
      commentsError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.loadCommentsSuccess,
    (state, { comments }): ManageSurveyState => ({
      ...state,
      comments,
      commentsLoading: false,
      commentsError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.loadCommentsFailure,
    (state, { error }): ManageSurveyState => ({
      ...state,
      comments: [],
      commentsLoading: false,
      commentsError: error,
    }),
  ),

  on(
    ManageSurveyActions.addComment,
    (state): ManageSurveyState => ({
      ...state,
      addingComment: true,
      addCommentError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.addCommentSuccess,
    (state, { comment }): ManageSurveyState => ({
      ...state,
      comments: [...state.comments, comment],
      addingComment: false,
      addCommentError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.addCommentFailure,
    (state, { error }): ManageSurveyState => ({
      ...state,
      addingComment: false,
      addCommentError: error,
    }),
  ),
];
